"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ParseLineItemDescription_1 = __importDefault(require("./ParseLineItemDescription"));
var lodash_1 = __importDefault(require("lodash"));
var Types_1 = require("@CommonFrontendBackend/QuoteV2/Types");
var Recurrence_1 = require("@CommonFrontendBackend/QuoteV2/Recurrence");
var cleanFieldName = function (field) { return field.toLowerCase().replace(/\W+/g, ""); };
var REQUIRED_FIXED_LINE_ITEM_KEYS = ["type", "description", "quantity", "rate"];
exports.default = (function (invoke) {
    var parseDescription = invoke(ParseLineItemDescription_1.default);
    var parseTextItem = function (rawItem) {
        var description = "";
        for (var key in rawItem) {
            var value = rawItem[key];
            var cleanedKey = cleanFieldName(key);
            if (cleanedKey === "description") {
                description = value;
                break;
            }
        }
        return {
            type: "text",
            description: !!description ? parseDescription(description) : "",
        };
    };
    var parseFixedCostItem = function (rawItem) {
        var newItem = {
            type: "fixedCost",
        };
        for (var key in rawItem) {
            var value = rawItem[key];
            var cleanedKey = cleanFieldName(key);
            if (cleanedKey === "description") {
                newItem.description = parseDescription(value);
            }
            else if (cleanedKey === "quantity") {
                newItem.quantity = parseFloat(value);
            }
            else if (cleanedKey === "costperitem") {
                if (newItem.rate == null) {
                    newItem.rate = {};
                }
                newItem.rate.rate = parseFloat(value);
            }
            else if (cleanedKey === "unitname") {
                if (newItem.rate == null) {
                    newItem.rate = {};
                }
                newItem.rate.unit = value;
            }
            else if (cleanedKey === "taxexempt") {
                value = value.toLowerCase();
                newItem.isTaxExempt = !(value === "false" || value === "f" || value === "0");
            }
            else if (cleanedKey === "isoptional") {
                value = value.toLowerCase();
                if (newItem.interactive == null) {
                    newItem.interactive = {};
                }
                newItem.interactive.isOptional = !(value === "false" || value === "f" || value === "0");
            }
            else if (cleanedKey === "recurringfrequency") {
                value = value.toLowerCase();
                if (!value) {
                    continue;
                }
                if (!Object.values(Types_1.RecurringFrequency).includes(value)) {
                    return null;
                }
                newItem.billingSchedule = {
                    type: Types_1.BillingScheduleType.Recurring,
                    frequency: value,
                };
            }
        }
        if (!newItem.billingSchedule) {
            newItem.billingSchedule = (0, Recurrence_1.createEmptyOneOffBillingSchedule)();
        }
        if (!REQUIRED_FIXED_LINE_ITEM_KEYS.every(function (key) { return lodash_1.default.has(newItem, key); }) ||
            newItem.rate.rate == null ||
            newItem.rate.unit == null) {
            return null;
        }
        return lodash_1.default.extend({
            discount: {},
            isTaxExempt: false,
            interactive: {
                isOptional: false,
                isOptionalQuantity: false,
            },
        }, newItem);
    };
    return function (rawItem) {
        var hasDescription = false;
        var isText = true;
        for (var field in rawItem) {
            var cleanedField = cleanFieldName(field);
            if (hasDescription && !isText) {
                break;
            }
            else if (cleanedField === "description") {
                hasDescription = true;
            }
            else if (rawItem[field].length > 0) {
                isText = false;
            }
        }
        if (!hasDescription) {
            return null;
        }
        else if (isText) {
            return parseTextItem(rawItem);
        }
        else {
            return parseFixedCostItem(rawItem);
        }
    };
});
